import moment from 'moment';

const getAmountOf = (start_date, end_date, units, amount = 1) => Math.floor(moment(end_date).diff(start_date, units, true) / amount) + 1;

const getDatesRange = (startDate, endDate, extraProps, data, amount, units) => {
    let requests = []
    let start_date = moment(startDate);
    let end_date = moment(endDate);
    const nRequests = getAmountOf(start_date, end_date, units, amount);
    let currentDate = moment(start_date);
    for (let i = 1; i <= nRequests; i++) {
        requests.push({
            ...data,
            ...extraProps,
            startDate: currentDate.format('MM-DD-YYYY'),
            endDate: i === nRequests ? end_date.format('MM-DD-YYYY') : moment(currentDate.add(amount, units)).add(-1, 'days').format('MM-DD-YYYY')
        });
    }

    return requests;
}

const getDateRangeInMonths = (startDate, endDate, extraProps, data, amount = 1) => {
    return getDatesRange(startDate, endDate, extraProps, data, amount, 'months');
}

const getDateRangeInWeeks = (startDate, endDate, extraProps, data, amount = 1) => {
    return getDatesRange(startDate, endDate, extraProps, data, amount, 'weeks');
}

const getDateRangeInDays = (startDate, endDate, extraProps, data, amount = 1) => {
    return getDatesRange(startDate, endDate, extraProps, data, amount, 'days');
}

export {
    getAmountOf,
    getDatesRange,
    getDateRangeInMonths,
    getDateRangeInWeeks,
    getDateRangeInDays
}